import { Action, createReducer, on } from '@ngrx/store';
import * as ZonesActions from '../actions/zones.actions';
import { Zones, ZonesFilters, ZonesDTO } from '../../commons/models/zone';

export interface ZonesState {
    list: ZonesDTO[];
    total: number;
    filters: ZonesFilters;
    selectedTenantId: number;
    includes: string[],
    currentPage: number,
    perPage: number,
    order: string,
    direction: string,
    dialogId: string,
    selectionDialogId: string,
    selectedZones: Zones[]
};

const initialState: ZonesState = {
    list: [],
    total: 0,
    includes: [],
    currentPage: 1,
    perPage: 25,
    order: null,
    direction: null,
    filters: null,
    dialogId: null,
    selectionDialogId: null,
    selectedTenantId: 1,
    selectedZones: []
};

const zonesReducer = createReducer(
    initialState,

    on(ZonesActions.loadZonesCompleted, (state, { zones, currentPage, total, perPage, order, direction, filters, includes }) => {
        return { ...state, list: zones, currentPage, total, perPage, order, direction, filters, includes };
    }),
    on(ZonesActions.zonesDialogOpened, (state, {dialogId}) => {
        return {...state, dialogId};
    }),
    on(ZonesActions.selectZoneSuccess, (state, { zone }) => {
        return { ...state, selectedTenants: []};
    }),

);

export function reducer(state: ZonesState | undefined, action: Action) {
  return zonesReducer(state, action);
}
